import React from "react";
import {message, Modal, Button} from "antd";
import PropTypes from "prop-types";

export class DeleteButton extends React.Component {
  state = { disabled: false };

  handleClick = contactlist => {
    if (!this.state.disabled) {
      this.setState({ disabled: true });
      message.info('Deleting contact list ' + contactlist.name);
      this.props.onDelete && this.props.onDelete(contactlist.id);
    }
  };

  confirmDelete = contactlist => {
    Modal.confirm({
      title: 'Are you sure you want to delete this contact list?',
      content: <span>If you delete this contact list, it will be immediately removed from the system. This is an irreversible action.</span>,
      okText: 'Yes',
      cancelText: 'No',
      onOk: () => this.handleClick(contactlist),
    })
  };

  render() {
    return <Button key={this.props.fauxKey} onClick={() => this.confirmDelete(this.props.contactlist)} className={''} icon={'usergroup-delete'}>Delete</Button>;
  }
}

DeleteButton.propTypes = {
  onDelete: PropTypes.func,
  fauxKey: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string,
};


// WEBPACK FOOTER //
// ./src/components/Settings/ContactLists/DeleteButton.js